import React, { useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { clearCart } from "../data/actions/cart";
import { useHistory } from "react-router-dom";
import { URLDevelopment } from "../helpers/URL";

const Checkout = () => {
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();
 const history = useHistory();

  const cart = useSelector((state) => state.cart.cart);

  const [loading, setLoading] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);

  const token = localStorage.getItem("token");

  const total = cart.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  // 🔐 Login Protection
  useEffect(() => {
    if (!token) {
      history.push("/login?redirect=checkout");
    }
  }, [token, history]);
// //const res = await axios.get(`${URLDevelopment}/api/user`);
  // 📦 Fetch User Addresses
  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        const { data } = await axios.get(
         `${URLDevelopment}/api/user/profile`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setAddresses(data.addresses || []);
      } catch (err) {
        console.error(err);
      }
    };

    if (token) fetchAddresses();
  }, [token]);

  const handlePayment = async () => {
  if (!stripe || !elements || !selectedAddress) {
    return alert("Please select a shipping address first.");
  }

  setLoading(true);

  try {
    // ✅ 1. Create payment intent
    const { data } = await axios.post(
      `${URLDevelopment}/api/payment/create-payment-intent`,
      { amount: total },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    // ✅ 2. Confirm payment
    const result = await stripe.confirmCardPayment(data.clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
      },
    });

    // ❌ PAYMENT ERROR
    if (result.error) {
      console.error("Stripe Error:", result.error.message);

      history.push("/payment-failed"); // ✅ redirect instead of alert
      return;
    }

    // ✅ SUCCESS
    if (result.paymentIntent.status === "succeeded") {
      try {
        // ✅ 3. Create order
        await axios.post(
          `${URLDevelopment}/api/orders`,
          {
            orderItems: cart,
            totalPrice: total,
            shippingAddress: selectedAddress,
            paymentResult: result.paymentIntent,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        // ✅ 4. Clear cart
        dispatch(clearCart());

        // ✅ 5. Redirect (NO ALERT)
        history.push("/payment-success");

      } catch (orderError) {
        console.error("Order Save Error:", orderError);

        // payment success but order failed
        history.push("/payment-success");
      }
    }
  } catch (err) {
    console.error("Payment Failed:", err);

    // ✅ global failure
    history.push("/payment-failed");
  } finally {
    setLoading(false);
  }
};
  return (
    <div className="min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8">

        {/* 🛒 Cart Summary */}
        <div className="bg-white rounded-xl shadow-md p-6">
          <h2 className="text-xl font-semibold mb-4">Order Summary</h2>

          {cart.length === 0 ? (
            <p className="text-gray-500">Your cart is empty.</p>
          ) : (
            <div className="space-y-4">
              {cart.map((item, index) => (
                <div key={index} className="flex justify-between border-b pb-2 text-sm">
                  <div>
                    <p className="font-medium">{item.name}</p>
                    <p className="text-gray-500">Qty: {item.quantity}</p>
                  </div>
                  <p className="font-semibold">
                    ₹{item.price * item.quantity}
                  </p>
                </div>
              ))}

              <div className="flex justify-between pt-4 text-lg font-bold">
                <span>Total</span>
                <span>₹{total}</span>
              </div>
            </div>
          )}
        </div>

        {/* 🏠 Address + Payment Section */}
        <div className="bg-white rounded-xl shadow-md p-6">
          <h2 className="text-xl font-semibold mb-4">
            Shipping Address
          </h2>

          {addresses.length === 0 && (
            <p className="text-red-500 mb-4">
              Please add a shipping address in your profile first.
            </p>
          )}

          {addresses.map((addr, index) => (
            <div key={index} className="border p-3 rounded mb-3">
              <input
                type="radio"
                name="address"
                className="mr-2"
                onChange={() => setSelectedAddress(addr)}
              />
              <span>
                {addr.fullName}, {addr.address}, {addr.city}, {addr.postalCode}, {addr.country}
              </span>
            </div>
          ))}

          {/* 💳 Show Payment Only If Address Selected */}
          {selectedAddress && (
            <>
              <h2 className="text-xl font-semibold mt-6 mb-4">
                Payment Details
              </h2>

              <div className="border rounded-lg p-4 mb-4">
                <CardElement
                  options={{
                    style: {
                      base: {
                        fontSize: "16px",
                        color: "#32325d",
                        "::placeholder": {
                          color: "#a0aec0",
                        },
                      },
                    },
                  }}
                />
              </div>

              <button
                onClick={handlePayment}
                disabled={!stripe || loading || cart.length === 0}
                className={`w-full py-3 rounded-lg font-semibold transition ${
                  loading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-blue-600 text-white hover:bg-blue-700"
                }`}
              >
                {loading ? "Processing..." : `Pay ₹${total}`}
              </button>

              <p className="text-xs text-gray-500 text-center mt-4">
                Secure payment powered by Stripe
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Checkout;
